import * as React from 'react'

export default function DownloadIcon(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) {
	return (
		<svg
			width={13}
			height={14}
			viewBox="0 0 13 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				d="M4.875.5v4.875h-3.25L6.5 10.25l4.875-4.875h-3.25V.5h-3.25zM0 11.875V13.5h13v-1.625H0z"
				fill="#08362F"
			/>
		</svg>
	)
}
